import './index.css'
import Interface from './scripts/Interface'
import WebGLManager from './scripts/WebGLManager'
import { formatPercent } from './scripts/helpers/FormatHelper'
import { loadAppData, getButtons, getChapterName, getSubliminalsPath } from './scripts/helpers/DataHelper'
import { easeUpdate } from './scripts/helpers/EaseHelper'
import { Mouse } from './scripts/helpers/MouseHelper'
import { addGestureViewer } from './scripts/helpers/3DEngineHelper'
import * as bowser from 'bowser'

// registerServiceWorker()

/**
 * test browser
 */
if (bowser.mobile || bowser.tablet) {
  document.getElementById('mobile-support').style.display = 'flex'
  throw new Error('Mobile version not available')
}
if (bowser.msie) {
  document.getElementById('browser-support').style.display = 'block'
  throw new Error('Browser not supported')
}

/**
 * constants
 */
const DELAY_BUTTON_MENU_SHOW = 5000
const appView = new Interface()
const webglManager = new WebGLManager(appView.canvas)
const loadingHandler = (progress, loaded, total) => appView.loaderPercent = formatPercent(progress)
const onActionRatioUpdate = (ratio, smoothRatio) => { webglManager.sceneManager.motionCam.ratio = ratio }
const onActionSwitchStart = () => { appView.menu.hide = true }
const onActionSwitchComplete = () => { setTimeout(() => webglManager.displayNext(), 1200)}

/**
 * variables
 */
let timeoutToogleMenu = null

/**
 * init webglManager
 */
webglManager.displayChapter = id => appView.chapter.display(id + 1, getChapterName(id))
webglManager.hideChapter = id => appView.chapter.hide()
webglManager.displaySceneHandler = id => {
  clearTimeout(timeoutToogleMenu)
  appView.updateMenu(id)
  appView.overlay.show()
  appView.displayAction(id, onActionSwitchStart, onActionRatioUpdate, onActionSwitchComplete)
  timeoutToogleMenu = setTimeout(() => appView.menu.hide = false, DELAY_BUTTON_MENU_SHOW)
}
webglManager.hideSceneHandler = id => {
  appView.hideAction()
  appView.overlay.hide()
}
webglManager.onBookOpen = () => {}
webglManager.onBookClose = () => {
  if (!appView.action.switched) {
    webglManager.sceneManager.reverseIntro()
  } else {
    if (!appView.menu.isOpen) {
      appView.menu.toggleMenu()
    }
  }
  appView.hideAction(true)
}

/**
 * init appView
 */
appView.onResize = resize
appView.onFrame = render
appView.onIntroComplete = () => webglManager.displayScene(0)

appView.resize()
appView.play()

/**
 * start app
 */
loadAppData(`${process.env.REACT_APP_ROOT_URL}/data/preload.json`)
  .then(onPreloadLoaded)

function onPreloadLoaded (data) {
  appView.loader.motionData = data
  appView.loader.show()
  loadAppData(`${process.env.REACT_APP_ROOT_URL}/data/data.json`)
    .then(onAppDataLoaded)
    .catch(error => { console.error('Error, no data found ...\n', error) })
}

function onAppDataLoaded (data) {
  let loadedWebgl = 0, totalWebgl = 0
  let loadedChapter = 0, totalChapter = 0
  let webglComplete = false, chapterComplete = false
  let progressTotal = 0, loadedTotal = 0, totalTotal = 0
  const selectButtonHandler = id => webglManager.displaySceneCut(id)
  const toggleMenuHandler = value => {
    webglManager.bookOpenFlag = !value
    value ? appView.overlay.fadeOut() : appView.overlay.fadeIn()
  }
  const checkProgress = type => (progress, loaded, total) => {
    switch (type) {
      case 'webgl':
        loadedWebgl = loaded
        totalWebgl = total
        break
      case 'chapter':
        loadedChapter = loaded
        totalChapter = total
        break
      default:
        return
    }
    loadedTotal = loadedWebgl + loadedChapter
    totalTotal = totalWebgl + totalChapter
    progressTotal = loadedTotal / totalTotal || 0
    loadingHandler(progressTotal, loadedTotal, totalTotal)
  }
  const checkComplete = () => {
    if (!webglComplete || !chapterComplete) return
    appView.hideLoader()
    addDebug()
    resize()
    webglManager.bookOpenFlag = true
    setTimeout(() => appView.intro.show(), 500)
  }

  appView.buildMenu(getButtons(), selectButtonHandler, toggleMenuHandler)

  webglManager.preloadAll(checkProgress('webgl')).then(() => {
    webglComplete = true
    checkComplete()
  })

  appView.chapter.preload(getSubliminalsPath(), checkProgress('chapter')).then(() => {
    chapterComplete = true
    checkComplete()
  })
}

function resize () {
  webglManager.resize()
}

function render (time, delta) {
  easeUpdate(time)
  webglManager.screen.radius = appView.actionRatio * 0.1 + 0.89
  webglManager.render(time, delta)
}

/**
 * debug
 */
function addDebug () {
  if (window.location.hash === '#about') {
    setTimeout(() => appView.intro.hide(), 800)
    document.getElementsByTagName('html')[0].className = 'state-about'
  }
  if (window.location.hash === '#drawer') {
    appView.displayAction(0, null, null, null, true)
    webglManager.displayScene = () => {}
    appView.menu.debug = true
    setTimeout(() => appView.intro.hide(), 800)
    appView.buildMenu(getButtons(), id => {
      appView.displayAction(id, null, null, null, true)
    })
    return
  }
  if (window.location.hash === '#book') {
    setTimeout(() => appView.intro.hide(), 800)
    webglManager.transition = false
    setTimeout(()=>webglManager.bookOpenFlag = false, 1000)
    webglManager.displaySceneHandler = () => {}
    addGestureViewer(webglManager.bookManager.container, window)

    appView.onFrame = (time, delta) => {
      easeUpdate(time)
      webglManager.bookManager.book.openRatio = (Mouse.rx + 1) * 0.5
      webglManager.render(time, delta)
    }

    return
  }
  if (window.location.hash !== '#debug') return
  const debugConfig = {
    negative: false,
    pause: false,
    textDebug: appView.textDebug
  }
  const pauseHandler = value => value ? appView.stop() : appView.play()
  const negativeHandler = value => value ? webglManager.switchMat() : null

  appView.menu.debug = true
  setTimeout(() => appView.intro.hide(), 800)

  appView.debugger.debugMotionCamera(webglManager.sceneManager.motionCam, () => render(), 'scene')
  appView.debugger.debugMotionCamera(webglManager.bookManager.motionCam, () => render(), 'book')
  appView.debugger.addFolder('debug')
  appView.debugger.addBoolean(debugConfig, 'negative', 'comics', negativeHandler)
  appView.debugger.addBoolean(debugConfig, 'pause', 'pause', pauseHandler)
  appView.debugger.addBoolean(webglManager, 'bookFlag', 'book', value => webglManager.bookFlag = value)
  appView.debugger.addBoolean(webglManager, 'bookOpenFlag', 'book open', value => webglManager.bookOpenFlag = value)
  appView.debugger.addBoolean(webglManager, 'postprocessing', 'post processing', value => webglManager.postprocessing = value)
  appView.debugger.addBoolean(webglManager, 'transition', 'transition', value => webglManager.transition = value)
  appView.debugger.addBoolean(webglManager, 'mouseMotionEnabled', 'mouse move', value => webglManager.mouseMotionEnabled = value)
  appView.debugger.addBoolean(debugConfig, 'textDebug', 'debug text', value => appView.textDebug = value)
  window.addEventListener('keyup', e => {
    e.preventDefault()
    return e.code === 'Space' ? webglManager.sceneManager.play() : null}
  );

  webglManager.bookFlag = true
  webglManager.postprocessing = true
}



// WEBPACK FOOTER //
// ./src/index.js